import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectPage from "../pages/portfolio/ProjectPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/portfolio/:slug",
    element: <ProjectPage />,
  },
  {
    path: "/en/portfolio/:slug",
    element: <ProjectPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
